<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { onMounted, onUnmounted, ref } from 'vue'
import { LanguageType } from '@/constants/language'
import router from '@/router'
import { useLanguageStore } from '@/stores/languageStore'
import { setCookie } from '@/utils/cookies'

const LanguageOptions = [
    { language: 'English', code: LanguageType.EN },
    { language: '简体中文', code: LanguageType.ZH_CN },
    { language: 'Indonesia', code: LanguageType.ID_ID },
    { language: 'Tiếng Việt', code: LanguageType.VI_VN },
    { language: 'ภาษาไทย', code: LanguageType.TH_TH },
    { language: '日本語', code: LanguageType.JA_JP },
    { language: '한국어', code: LanguageType.KO_KR },
    { language: 'မြန်မာစာ', code: LanguageType.MY_MM },
    { language: 'हिन्दी', code: LanguageType.HI_IN },
    { language: 'Português', code: LanguageType.PT_BR },
    { language: 'ភាសាខ្មែរ', code: LanguageType.KM_KH },
    { language: 'বাংলা', code: LanguageType.BN_BD },
]

const store = useLanguageStore()
const { language } = storeToRefs(store)
const isShow = ref(false)
const dropdownRef = ref<HTMLElement>()
const languageDropdown = () => {
    isShow.value = !isShow.value
}

function addLangToRouteQuery(langISOString: string) {
    // Hector Session Language will be updated by query string
    // It is only for refresh page via old Hector
    router.push({
        path: router.currentRoute.value.fullPath,
        query: { ...router.currentRoute.value.query, lg: langISOString },
    })
}

const handleUpdateLanguage = (newLanguage: LanguageType) => {
    language.value = newLanguage
    isShow.value = false

    const langISOString = newLanguage
        ? newLanguage.replace('_', '-').toLowerCase()
        : LanguageType.EN.replace('_', '-').toLowerCase()

    setCookie('LanguageType', newLanguage)
    setCookie('lang', langISOString)
    addLangToRouteQuery(langISOString)
}

const handleDocumentClick = (event: MouseEvent) => {
    if (!dropdownRef.value?.contains(event.target as Node)) {
        isShow.value = false
    }
}

onMounted(() => {
    document.addEventListener('click', handleDocumentClick, true)
})

onUnmounted(() => {
    document.removeEventListener('click', handleDocumentClick, true)
})
</script>

<template>
    <div ref="dropdownRef" class="language-container">
        <button class="language-btn" type="button" @click="languageDropdown()">
            <img class="language-btn-earth" src="../../assets/images/icon_language.svg" alt="language">
            <img class="language-btn-arrow" src="../../assets/images/icon_dropdownArrow.svg" alt="dropdownArrow">
        </button>
        <div v-if="isShow" id="language-menu" class="language-menu _t-show">
            <a
                v-for="option in LanguageOptions"
                :key="option.code"
                class="language-item"
                @click="handleUpdateLanguage(option.code)"
            >
                {{ option.language }}
            </a>
        </div>
    </div>
</template>
